import { useEffect, useState } from 'react';
import S from './AdminLogin.module.scss';
import Admin from '../index';

const ADMIN_TOKEN = process.env.REACT_APP_IVY_ADMIN_TOKEN;
const AdminLogin = () => {
  const [password, setPassword] = useState<string>('');
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const handleLogin = () => {
    if (password === ADMIN_TOKEN) {
      setIsAdmin(true);
      setErrorMessage('');
    } else {
      setErrorMessage('비밀번호가 일치하지 않습니다.');
    }
  };

  useEffect(() => {
    if (password !== ADMIN_TOKEN) {
      setIsAdmin(false);
    }
  }, [password]);

  if (isAdmin) {
    return <Admin masterToken={password} />;
  }

  return (
    <div className={S.container}>
      <div className={S.loginBox}>
        <h2 className={S.heading}>관리자 로그인</h2>
        <input
          type="password"
          placeholder="비밀번호 입력"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={S.input}
        />
        {errorMessage && <p className={S.errorText}>{errorMessage}</p>}
        <br />
        <button onClick={handleLogin} className={S.button}>
          로그인
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
